import { ICDocIcon, ICExeIcon, ICIsoIcon, ICTxtIcon, ICZipIcon, PdfModernIcon, ICCsvIcon, ICXlsIcon } from '../icons'
import * as images from '../images'

const fileIcons = {
  doc: <ICDocIcon className="doc-icon" />,
  pdf: <PdfModernIcon className="doc-icon" />,
  txt: <ICTxtIcon className="doc-icon" />,
  iso: <ICIsoIcon className="doc-icon" />,
  zip: <ICZipIcon className="doc-icon" />,
  exe: <ICExeIcon className="doc-icon" />,
  uc3: <ICExeIcon className="doc-icon" />,
  csv: <ICCsvIcon className="doc-icon" />,
  xlsx: <ICXlsIcon className="doc-icon" />,
}

export const getFileIcon = (fileName) => {
  const extension = fileName?.split('.').pop().toLowerCase()
  return fileIcons[extension] || <PdfModernIcon className="doc-icon" />
}

export const capitalizeFirstLetter = (string) => {
  if (!string) {
    return ''
  }

  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const capitalizeWords = (sentence) => {
  if (!sentence) {
    return ''
  }

  return sentence
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const JSONdeepClone = (object) => {
  return JSON.parse(JSON.stringify(object))
}

export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType })

  const anchor = document.createElement('a')
  anchor.download = fileName
  anchor.href = window.URL.createObjectURL(blob)

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })

  anchor.dispatchEvent(clickEvent)
  anchor.remove()
}

export const downloadFileUTF8 = ({ data, fileName, fileType }) => {
  const bom = '\uFEFF'
  const finalContent = bom + data

  const blob = new Blob([finalContent], { type: fileType })

  const anchor = document.createElement('a')
  anchor.download = fileName
  anchor.href = window.URL.createObjectURL(blob)

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })

  anchor.dispatchEvent(clickEvent)
  anchor.remove()
}

export function getImageByModel(model) {
  if (images[model?.toLowerCase().replace(/ |-/g, '_').replace('+', 'plus') + '_200x200']) {
    return images[model?.toLowerCase().replace(/ |-/g, '_').replace('+', 'plus') + '_200x200']
  } else {
    return images.no_image_200x200
  }
}

export const disableScrolling = () => {
  const x = window.scrollX
  const y = window.scrollY

  window.onscroll = function () {
    window.scrollTo(x, y)
  }
}

export const enableScrolling = () => {
  window.onscroll = function () {}
}

export const formatPhone = (phone) => {
  let sanitizedPhone = phone.replace(/[^\d]/g, '')

  // returns: "x", "xx", "xxx"
  if (sanitizedPhone.length < 4) return sanitizedPhone

  // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
  if (sanitizedPhone.length < 7) return `${sanitizedPhone.slice(0, 3)}-${sanitizedPhone.slice(3)}`

  // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
  if (sanitizedPhone.length < 11) return `${sanitizedPhone.slice(0, 3)}-${sanitizedPhone.slice(3, 6)}-${sanitizedPhone.slice(6, 10)}`

  return `${sanitizedPhone.slice(0, 3)}-${sanitizedPhone.slice(3, 6)}-${sanitizedPhone.slice(6, 10)}-${sanitizedPhone.slice(10)}`
}

//convert seconds to minutes
export const convertSeconds = (seconds) => {
  var d = new Date(seconds * 1000)
  var m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
  var s = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
  return m + ':' + s
}

//convert seconds to full date
export const convertSecondsFullTime = (seconds) => {
  // var d = new Date(seconds * 1000);
  // var h = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
  // var m = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
  // var s = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
  // return h + ":" + m + ":" + s;
  var date = new Date(seconds * 1000)
  var year = date.getUTCFullYear()
  var month = ('0' + (date.getUTCMonth() + 1)).slice(-2)
  var day = ('0' + date.getUTCDate()).slice(-2)
  var hours = ('0' + date.getUTCHours()).slice(-2)
  var minutes = ('0' + date.getUTCMinutes()).slice(-2)
  var second = ('0' + date.getUTCSeconds()).slice(-2)
  return `${year}-${month}-${day} ${hours}:${minutes}:${second}`
}

//Format date string
export const convertDate = (date) => {
  var year = date?.substring(0, 4)
  var month = date?.substring(4, 6)
  var day = date?.substring(6, 8)
  var hours = date?.substring(8, 10)
  var minutes = date?.substring(10, 12)
  var seconds = date?.substring(12, 14)

  if (hours && minutes && seconds) {
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return year + '-' + month + '-' + day
  }
}

// export const convertDateWithTandZ = (dateString) => {
//   const date = new Date(dateString);
//   const isoString = date.toISOString();
//   const formattedDate = new Date(isoString);
//   const year = formattedDate.getUTCFullYear();
//   const month = String(formattedDate.getUTCMonth() + 1).padStart(2, '0');
//   const day = String(formattedDate.getUTCDate()).padStart(2, '0');
//   const hours = String(formattedDate.getUTCHours()).padStart(2, '0');
//   const minutes = String(formattedDate.getUTCMinutes()).padStart(2, '0');
//   const seconds = String(formattedDate.getUTCSeconds()).padStart(2, '0');
//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// }

export const convertDateWithTandZ = (dateString) => {
  const date = new Date(dateString)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Ensure 24-hour format
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Use browser's time zone
  }

  const localDateString = date.toLocaleString('en-US', options)

  const year = localDateString.slice(6, 10)
  const month = localDateString.slice(0, 2)
  const day = localDateString.slice(3, 5)
  const time = localDateString.slice(11)

  return `${year}-${month}-${day} ${time}`
}

export const formatTime = (timeFormat, time) => {
  if (!time) return ''

  if (timeFormat === '24hr') return time

  const [hours, minutes, seconds] = time.split(':')
  const hr = parseInt(hours, 10)
  const isPM = hr >= 12
  const formattedHour = hr % 12 === 0 ? 12 : hr % 12
  const amPm = isPM ? 'PM' : 'AM'
  return `${formattedHour}:${minutes}:${seconds} ${amPm}`
}

export const celsiusToFahrenheit = (celsius) => (celsius * 9) / 5 + 32

export const isG4orG4PlusProduct = (serial) => {
  return serial?.is_g4_plus || serial?.model?.includes('G4')
}

export const groupModelsByDevice = (models) => {
  let modelsByDevice = ''

  if (!models || models.length === 0) {
    return modelsByDevice
  }

  const uniqueProductsWithModels = []

  models.forEach((model) => {
    const splitModel = model.split(' ')
    const product = splitModel[0]
    const technology = product !== 'STATCLAVE' ? (splitModel.length > 2 ? splitModel[splitModel.length - 1] : '') : splitModel[1]

    const existingProduct = uniqueProductsWithModels.find((item) => item.product === product && item.technology === technology)
    if (!existingProduct) {
      uniqueProductsWithModels.push({ product, technology, models: [product !== 'STATCLAVE' ? splitModel[1] : []] })
    } else {
      if (product !== 'STATCLAVE') {
        existingProduct.models.push(splitModel[1])
      }
    }
  })

  uniqueProductsWithModels.forEach((item) => {
    const modelsString = item.models.join('/')
    modelsByDevice += `${item.product} ${modelsString} ${item.technology}, `
  })

  modelsByDevice = modelsByDevice.slice(0, -2)

  return modelsByDevice
}

const howToVideoPriorityByLanguage = {
  ES: ['mgEUStMueaU', 'MFKQzRxklqE', '5YcNK_aF1w', 'SBHyEQRtAMM'],
  DE: ['35nc52Tzj6A', 'NYI_fsgwTjw', 'TR8jjwUkDaY', '3bfgIYk7cDY'],
}

const defaultHowToVideoPriority = ['nV22l496LoA', 'Jbt26YauGZk', 'UuRhot72zv0', 'dZgGHQ4Kldg']

export const getDashboardHowToVideos = (videos = [], selectedLanguage) => {
  const limit = 4
  const priorityVideos = howToVideoPriorityByLanguage[selectedLanguage] || defaultHowToVideoPriority

  if (!Array.isArray(videos) || videos.length === 0 || limit <= 0) return []

  const selected = []
  const selectedIds = new Set()

  const addVideo = (video) => {
    if (!video?.video_id || selectedIds.has(video.video_id) || selected.length >= limit) return
    selected.push(video)
    selectedIds.add(video.video_id)
  }

  const isHowToVideo = (video) => {
    const normalized = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/[-_]/g, ' ')
    const includesHowTo = (value) => normalized(value).includes('how to')

    if (includesHowTo(video?.video_type) || includesHowTo(video?.videoType) || includesHowTo(video?.category)) {
      return true
    }

    if (Array.isArray(video?.categories)) {
      return video.categories.some((category) => includesHowTo(typeof category === 'string' ? category : category?.name))
    }

    return false
  }

  priorityVideos.forEach((videoId) => {
    const video = videos.find((item) => item?.video_id === videoId)
    if (video) addVideo(video)
  })

  if (selected.length < limit) {
    videos.filter((video) => isHowToVideo(video)).forEach((video) => addVideo(video))
  }

  return selected.slice(0, limit)
}

export const replaceExtension = (label) => {
  const knownExtensions = Object.keys(fileIcons)
  const extensionPattern = new RegExp(`\\.(?:${knownExtensions.join('|')})$`, 'i')

  return label?.split('_').join(' ').replace(extensionPattern, '')
}

export const transformChartData = (apiData = []) => {
  const raw = (Array.isArray(apiData) ? apiData : apiData?.data || []).filter((d) => d && d.year != null && d.month != null && d.model && d.model !== '')

  const add = (a, b) => (a || 0) + (Number(b) || 0)

  // --- MONTHLY ---
  const monthlyMap = {}
  raw.forEach(({ year, month, model, totalRegistered }) => {
    const y = Number(year)
    const m = Number(month)
    const key = y * 12 + (m - 1)
    if (!monthlyMap[key]) monthlyMap[key] = {}
    monthlyMap[key][model] = add(monthlyMap[key][model], totalRegistered)
  })

  const monthly = Object.keys(monthlyMap)
    .map(Number)
    .sort((a, b) => a - b)
    .map((k) => {
      const y = Math.floor(k / 12)
      const m = (k % 12) + 1
      const mm = m < 10 ? '0' + m : '' + m
      return { date: `${mm}/${y}`, ...monthlyMap[k] }
    })

  // --- QUARTERLY ---
  const quarterlyMap = {}
  raw.forEach(({ year, month, model, totalRegistered }) => {
    const y = Number(year)
    const m = Number(month)
    const q = Math.floor((m - 1) / 3) + 1
    const key = y * 4 + (q - 1)
    if (!quarterlyMap[key]) quarterlyMap[key] = {}
    quarterlyMap[key][model] = add(quarterlyMap[key][model], totalRegistered)
  })

  const quarterly = Object.keys(quarterlyMap)
    .map(Number)
    .sort((a, b) => a - b)
    .map((k) => {
      const y = Math.floor(k / 4)
      const q = (k % 4) + 1
      return { date: `Q${q}/${y}`, ...quarterlyMap[k] }
    })

  // --- YEARLY ---
  const yearlyMap = {}
  raw.forEach(({ year, model, totalRegistered }) => {
    const y = Number(year)
    if (!yearlyMap[y]) yearlyMap[y] = {}
    yearlyMap[y][model] = add(yearlyMap[y][model], totalRegistered)
  })

  const yearly = Object.keys(yearlyMap)
    .map(Number)
    .sort((a, b) => a - b)
    .map((y) => ({ date: String(y), ...yearlyMap[y] }))

  return { month: monthly, quarter: quarterly, year: yearly }
}

export function getMonthName(month, short = false) {
  if (!month) return ''
  const monthIndex = parseInt(month, 10) - 1
  if (monthIndex < 0 || monthIndex > 11) return ''

  const monthNames = short
    ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  return monthNames[monthIndex]
}

const toLocalISOString = (d) => {
  const offMs = d.getTimezoneOffset() * 60000
  return new Date(d.getTime() - offMs).toISOString().slice(0, -1)
}

export const getLastNYearsRangeISO = (n = 5) => {
  const end = new Date()
  const start = new Date()
  start.setFullYear(end.getFullYear() - n)
  start.setHours(0, 0, 0, 0)
  end.setHours(23, 59, 59, 999)
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    startISO: toLocalISOString(start),
    endISO: toLocalISOString(end),
    timeZone,
  }
}

export const deriveAllowedRegionsFromCountries = (selectedCountryNames = [], allCountries = []) => {
  if (!Array.isArray(selectedCountryNames) || selectedCountryNames.length === 0) return []
  const matchedRegions = new Set()
  for (const country of allCountries) {
    if (selectedCountryNames.includes(country.name) && country.region) {
      matchedRegions.add(country.region)
    }
  }
  return Array.from(matchedRegions)
}

export const sortModelsAlphabetically = (models = []) => {
  try {
    return [...models].sort((a, b) => a?.toString().localeCompare(b?.toString(), undefined, { sensitivity: 'base' }))
  } catch (e) {
    console.error('Error sorting models:', e)
    return models
  }
}

